import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import TreeView from '@material-ui/lab/TreeView';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import makeStyles from "@material-ui/core/styles/makeStyles";
import TreeRender from "./TreeRender";
import {useContextMenu} from "../../../../Hooks";
import MenuDesignerContext from "../../../../ContextComponents/MenuDesignerContext";
import AddNewItemButton from "../../../SchemaDesigner/SchemaProperties/Schema/AddNewItemButton";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles(() => ({
    container: {
        padding: 10,
        overflow: 'hidden'
    },
    root: {
        flexGrow: 1,
    },
}));

const MenuItems = () => {
    const classes = useStyles();
    const {menu, selectItem, selectedItem: {path}, onCreateItem, onRemoveItem, onChangeIndent, onChangePosition} = useContext(MenuDesignerContext);
    const {ContextMenu, onOpen} = useContextMenu({
        addAfter: onCreateItem,
        addBefore: onCreateItem,
        remove: onRemoveItem,
        changeIndent: onChangeIndent,
        changePosition: onChangePosition
    });

    return (
        <div className={classes.container}>
            <TreeView
                className={classes.root}
                selected={path}
                onNodeSelect={(e, nodeId) => selectItem(nodeId)}
                defaultCollapseIcon={<ArrowDropDownIcon/>}
                defaultExpandIcon={<ArrowRightIcon/>}
                defaultEndIcon={<div style={{width: 24}}/>}
            >
                {TreeRender({onOpen, menu})}
            </TreeView>
            <Divider style={{marginTop: 5}}/>
            <AddNewItemButton
                index={menu.length}
                path={''}
                createNewItem={onCreateItem}
                title={'New menu item'}
            />
            <ContextMenu/>
        </div>
    )
};

export default MenuItems;

MenuItems.propTypes = {
    menu: PropTypes.array,
    selectItem: PropTypes.func,
    selectedItem: PropTypes.object,
    onCreateItem: PropTypes.func,
    onRemoveItem: PropTypes.func,
    onChangeIndent: PropTypes.func,
    onChangePosition: PropTypes.func
};